var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 31.884 26.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21409",
    "data-name": "Group 21409",
    transform: "translate(-1.999 -7.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21410",
    "data-name": "Group 21410",
    transform: "translate(1.999 7.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36998",
    "data-name": "Path 36998",
    d: "M28.908,21.3a1.383,1.383,0,0,1,1.381,1.381,1.063,1.063,0,0,0,2.126,0,3.512,3.512,0,0,0-2.444-3.341v-.948a1.063,1.063,0,1,0-2.126,0v.948a3.506,3.506,0,0,0,1.063,6.847,1.381,1.381,0,1,1-1.381,1.381,1.063,1.063,0,0,0-2.126,0,3.512,3.512,0,0,0,2.444,3.341v.948a1.063,1.063,0,0,0,2.126,0v-.948a3.506,3.506,0,0,0-1.063-6.847,1.381,1.381,0,0,1,0-2.762Z",
    transform: "translate(-12.966 -11.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36999",
    "data-name": "Path 36999",
    d: "M6.43,22.168l2.616-2.616a1.063,1.063,0,1,0-1.5-1.5l-.688.688a11.195,11.195,0,0,1,21.683-2.126,1.063,1.063,0,1,0,2.01-.69,13.328,13.328,0,0,0-25.867,3l-.868-.868a1.063,1.063,0,0,0-1.5,1.5l2.616,2.616a1.062,1.062,0,0,0,1.5,0Z",
    transform: "translate(-1.999 -6.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37000",
    "data-name": "Path 37000",
    d: "M36.461,30.729l-2.616-2.616a1.063,1.063,0,0,0-1.5,0l-2.616,2.616a1.063,1.063,0,0,0,1.5,1.5l.688-.688a11.195,11.195,0,0,1-21.683,2.126,1.063,1.063,0,0,0-2.01.69,13.328,13.328,0,0,0,25.867-3l.868.868a1.063,1.063,0,1,0,1.5-1.5Z",
    transform: "translate(-4.889 -16.707)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceTeams);
export default __webpack_public_path__ + "static/media/finance-teams.7b57d21bccf22f24a98d7727751bdd9e.svg";
export { ForwardRef as ReactComponent };